import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss'
import App from './App.vue'
import router from './router'
import store from './store'
import { getToken } from '@/utils/auth'

Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

const whiteList = ['/login']
router.beforeEach(async (to, from, next) => {
  if (whiteList.includes(to.path)) {
    next()
    return
  }
  const hasToken = getToken()
  if (!hasToken) {
    next('/login')
    return
  }
  const hasInfo = store.getters.admin && store.getters.admin.id
  if (hasInfo) {
    next()
    return
  }
  try {
    await store.dispatch('user/getInfo')
    next()
  } catch (e) {
    await store.dispatch('user/resetToken')
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
